import request from '@/config/axios'

export interface CertificationPageQuery {
  pageNo: number
  pageSize: number
  certType: number
  auditStatus?: number
  userNickname?: string
  realName?: string
  companyName?: string
  businessLicenseNo?: string
  createTimeStart?: string
  createTimeEnd?: string
}

export const getCertificationPage = (params: CertificationPageQuery) =>
  request.get({ url: '/bosscircle/certification/page', params })

export const auditCertification = (data: {
  id: number
  auditStatus: number
  auditRemark?: string
}) => request.put({ url: '/bosscircle/certification/audit', data })

export const getAuditCounts = (certType: number) =>
  request.get<Record<number, number>>({
    url: '/bosscircle/certification/audit-counts',
    params: { certType }
  })

export const batchAuditCertification = (ids: number[], auditStatus: number, auditRemark?: string) =>
  request.put({
    url: '/bosscircle/certification/batch-audit',
    data: { ids, auditStatus, auditRemark }
  })

/** 隐藏/恢复公域徽标（仅已通过） */
export const updateCertificationBadgeHidden = (data: {
  id: number
  hidden: boolean
  reason?: string
}) => request.put({ url: '/bosscircle/certification/badge-hidden', data })
